<!--材料预约列表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="organizationCode"
          v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
          selectType="selectAssemble"
          :selectData="inventOrg"
          :disabled="isDisableOrganization"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
          @change="inventOrgValueOnChange"
        />
        <global-select
          slot="workshopCode"
          :value.sync="queryParams.workshopCode"
          :selectData="workshopList"
          selectType="selectFilter"
          :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiTeamExport" ref="download" />
        <download-modal :apiFun="apiTeamEmployeeExport" ref="downloadForEmployee" />
        <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="() => handleOk(false)" />
        <import-excel ref="importExcelForEmployeeRef" :downloadParams="downloadParamsForEmployee" :uploadParams="uploadForEmployee" @refresh="() => handleOk(false)" />
        <create-modal ref="createModalRef" @refresh="handleOk" />
        <create-employee-modal v-if="tableActiveIndex === '1'" ref="createEmployeeModalRef" :select-rows="selectedRows" @refresh="handleOk" />
        <a-button v-if="tableActiveIndex === '1'" v-hasPermi="['bom:bomTeamCc:save']" type="primary" :loading="loading" @click="onCreate">新增</a-button>
        <a-button v-hasPermi="['bom:bomTeamCc:remove', 'bom:bomTeamEmployeeCc:remove']" :loading="loading" @click="onDelete">删除</a-button>
        <a-button v-if="tableActiveIndex === '1'" v-hasPermi="['bom:bomTeamEmployeeCc:save']" type="primary" :loading="loading" @click="onEmployeeCreate">添加人员</a-button>
        <a-button v-if="tableActiveIndex === '1'" type="primary" :loading="loading" v-hasPermi="['bom:bomTeamCc:import']" @click="handleImport">导入班组</a-button>
        <a-button v-if="tableActiveIndex === '1'" type="primary" :loading="loading" v-hasPermi="['bom:bomTeamEmployeeCc:import']" @click="handleImportForEmployee">导入人员</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['bom:bomTeamCc:export', 'bom:bomTeamScheduleCc:export']" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-tabs v-model="tableActiveIndex" default-active-key="1">
          <a-tab-pane key="1" tab="班组信息">
            <!-- 表格 -->
            <ls-api-table
              ref="dataTable"
              :columns="columns"
              :tableProps="tableProps"
              :selectedRows.sync="selectedRows"
              :multi-select="true"
              @selectedRowChange="selectedRowChange"
              rowKey="id"
              :scroll="{ fixScreen: true, x: 1000 }"
            >
              <!-- 班组名称 -->
              <template slot="teamName" slot-scope="{ record, text }">
                <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
                <a-input v-else v-model="record.teamName" placeholder="请输入" :maxLength="40" />
              </template>
              <!-- 定编人数 -->
              <template slot="quota" slot-scope="{ record, text }">
                <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
                <a-input-number v-else v-model="record.quota" :precision="0" :min="1"/>
              </template>
              <!-- 备注 -->
              <template slot="remark" slot-scope="{ record, text }">
                <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
                <a-input v-else v-model="record.remark" placeholder="请输入" :maxLength="100" />
              </template>
              <template slot="workshopDesc" slot-scope="{ record, text }">
                <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
                <global-select
                  v-else
                  class="pub-select"
                  v-model="record.workshopCode"
                  :selectData="workshopTableList"
                  selectType="selectFilter"
                  :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
                />
              </template>
              <span slot="operation" slot-scope="text">
                <a
                  v-if="(!isEdit || currentId !== text.record.id)"
                  v-hasPermi="['bom:bomTeamCc:save']"
                  @click="handleEdit(text.record)"
                >编辑</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
                <a class="ml10" @click="handleLog(text.record.id, { types: '2,6' })">日志</a>
              </span>
            </ls-api-table>
          </a-tab-pane>
          <a-tab-pane key="2" tab="人员信息" force-render>
            <!-- 表格 -->
            <ls-api-table
              ref="dataTableForEmployee"
              :columns="columnsForEmployee"
              :tableProps="tablePropsForEmployee"
              :selectedRows.sync="selectedRowsForEmployee"
              :multi-select="true"
              @selectedRowChange="selectedRowChangeForEmployee"
              rowKey="id"
              :scroll="{ fixScreen: true, x: 1000 }"
            >
              <!-- 生效日期 -->
              <template slot="dateSlot" slot-scope="{ record, text, column }">
                <span v-if="!isEditForEmployee || currentIdForEmployee !== record.id">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
                <a-date-picker v-else v-model="record[column.key]" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" size="small"/>
              </template>
              <span slot="operation" slot-scope="text">
                <a
                  v-if="(!isEditForEmployee || currentIdForEmployee !== text.record.id)"
                  v-hasPermi="['bom:bomTeamEmployeeCc:save']"
                  @click="handleEditForEmployee(text.record)"
                >编辑</a>
                <a v-if="isEditForEmployee && currentIdForEmployee === text.record.id" @click="handleSaveForEmployee(text.record)">保存</a>
                <a v-if="isEditForEmployee && currentIdForEmployee === text.record.id" @click="handleCancelForEmployee(text.record)" class="ml10">取消</a>
                <a class="ml10" @click="handleLog(text.record.id, { type: 3})"
                >日志</a>
              </span>
            </ls-api-table>
          </a-tab-pane>
        </a-tabs>
        <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'

import {
  apiTeamList,
  apiTeamUpdate,
  apiTeamExport,
  apiTeamDel,
  apiTeamEmployeeList,
  apiTeamEmployeeUpdate,
  apiTeamEmployeeExport,
  apiTeamEmployeeDel,
  apiGetLog
 } from '@/api/mes/productionPrepare/teamManage'
import { apiBomWorkshopFindList } from '@/api/mes/productionPrepare/attributeMaintenance'
import createModal from './components/create-modal.vue'
import createEmployeeModal from './components/create-employee-modal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'

import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'TeamManage',
  components: { DownloadModal, createModal, ImportExcel, createEmployeeModal, OperationLogModel },
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  data() {
    return {
      tableActiveIndex: '1', // 列表tab
      currentEditOrganizationCode: '', // 用于记录当前修改行的所属组织编码，用于避免多次调用所属车间下拉框接口
      // #region 表格1配置
      apiTeamExport,
      loading: false, // 请求loading
      isEdit: false,
      currentId: '',
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiTeamList, false),
        pageCurrent: true
      },
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/bom/team/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'bom/team/template',
        name: `班组导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      workshopList: [], // 车间列表
      workshopTableList: [], // 车间列表 - 用于列表编辑
      // 查询参数
      queryParams: {
        desOrganizationCode: undefined,
        organizationCode: undefined,
        workshopCode: undefined,
        teamName: undefined,
        teamCode: undefined
      },
      formList: [
        { label: '组织', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '车间', decorator: ['workshopCode'], type: 'workshopCode' },
        { label: '班组编码', decorator: ['teamCode'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '班组名称', decorator: ['teamName'], type: 'input', attrs: { placeholder: '请输入' } }
      ],
      // 表格字段
      columns: [
        { title: '班组编码', dataIndex: 'teamCode', align: 'center', width: 200 },
        { title: '班组名称', dataIndex: 'teamName', scopedSlots: { customRender: 'teamName' }, align: 'center', width: 140 },
        { title: '所属加工组织', dataIndex: 'organizationName', align: 'center', width: 140 },
        {
          title: '所属车间',
          dataIndex: 'workshopDesc',
          scopedSlots: {
            customRender: 'workshopDesc'
          },
          align: 'center',
          width: 200
        },
        { title: '定编人数', dataIndex: 'quota', scopedSlots: { customRender: 'quota' }, align: 'center', width: 140 },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, align: 'center', width: 140 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        {
          title: '操作',
          width: 125,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      logLoading: false, // 日志loading
      logList: [], // 日志列表
      // #endregion
      // #region 表格2配置
      apiTeamEmployeeExport,
      isEditForEmployee: false,
      currentIdForEmployee: '',
      selectedRowKeysForEmployee: [],
      selectedRowsForEmployee: [],
      // 表格配置
      tablePropsForEmployee: {
        requestApi: generateLsTableResData(apiTeamEmployeeList, false),
        pageCurrent: true
      },
      // 班组人员导入参数
      uploadForEmployee: {
        url: process.env.VUE_APP_API_BASE_URL + '/bom/team/employee/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParamsForEmployee: {
        method: 'post',
        url: 'bom/team/employee/template',
        name: `班组人员导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      // 表格字段
      columnsForEmployee: [
        { title: '班组编码', dataIndex: 'teamCode', align: 'center', width: 200 },
        { title: '班组名称', dataIndex: 'teamName', align: 'center', width: 140 },
        { title: '人员编码', dataIndex: 'employeeCode', align: 'center', width: 200 },
        { title: '姓名', dataIndex: 'employeeName', align: 'center', width: 140 },
        { title: '系统账号', dataIndex: 'rmsAccount', align: 'center', width: 140 },
        { title: '性别', dataIndex: 'sex', align: 'center', width: 100 },
        {
          title: '生效日期',
          dataIndex: 'effectiveStartTime',
          scopedSlots: { customRender: 'dateSlot' },
          align: 'center',
          width: 160
        },
        {
          title: '失效日期',
          dataIndex: 'effectiveEndTime',
          scopedSlots: { customRender: 'dateSlot' },
          align: 'center',
          width: 160
        },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        {
          title: '操作',
          width: 125,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
      // #endregion
    }
  },
  created() {
    apiBomWorkshopFindList({
      workshopStatus: "Y",
      organizationCode: this.organizationCodeOrigin
    }).then(res => {
      if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
    });
    this.queryParams.organizationCode = this.organizationCodeOrigin;
    this.queryParams.desOrganizationCode = this.organizationCodeOrigin;
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 加工组织
    inventOrgValueOnChange (val, status) {
      this.queryParams.workshopCode = '';
      apiBomWorkshopFindList({ organizationCode: val, workshopStatus: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
      })
    },
    // 行选中
    selectedRowChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      // 如果上一个修改行的所属组织与当前行的所属组织不一样，重新获取所属车间
      if (this.currentEditOrganizationCode !== record.organizationCode) {
        apiBomWorkshopFindList({
          workshopStatus: "Y",
          organizationCode: record.organizationCode
        }).then(res => {
          if (res && res.length > 0) {
              this.workshopTableList = res
            } else {
              this.workshopTableList = []
            }
        });
        this.currentEditOrganizationCode = record.organizationCode
      }

      this.isEdit = true
      this.currentId = record.id
    },
    // 保存
    handleSave(record) {
      if (!record?.teamName) {
        this.$message.warning('请输入班组名称')
        return
      }

      if (!record?.workshopCode) {
        this.$message.warning('请输入所属车间')
        return
      }

      this.loading = true

      apiTeamUpdate(record)
        .then((res) => {
          if (res?.code === 200) {
            this.$message.success('编辑成功')
            this.handleOk(true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false
      this.currentId = ''
      this.isEditForEmployee = false
      this.currentIdForEmployee = ''
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)

      this.$refs.dataTableForEmployee.searchParams = cloneDeep(params)
      this.$refs.dataTableForEmployee.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        desOrganizationCode: this.organizationCodeOrigin,
        organizationCode: this.organizationCodeOrigin,
        teamName: undefined,
        teamCode: undefined,
        rmsAccount: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.dataTableForEmployee.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 新增
    onCreate() {
      this.$refs.createModalRef.show()
    },
    onEmployeeCreate() {
      if(this.selectedRows?.length !== 1) {
        return this.$message.warning("请勾选一项单据进行操作")
      }
      this.$refs.createEmployeeModalRef.show()
    },
    // 删除
    onDelete() {
      if (this.tableActiveIndex === '1') {
        if(this.selectedRows?.length < 1) {
          return this.$message.warning("请勾选单据进行操作")
        }
      } else if (this.tableActiveIndex === '2') {
        if(this.selectedRowsForEmployee?.length < 1) {
          return this.$message.warning("请勾选单据进行操作")
        }
      }

      const self = this
      self.$confirm({
        title: '提示',
        content: '请确认是否删除勾选单据？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          let params = [];
          if (this.tableActiveIndex === '1') {
            params = self.selectedRows.map(item => item.teamCode)
            apiTeamDel(params).then(res => {
              if (res?.code === 200) {
                self.$message.success(res?.msg || '操作成功')
                self.handleOk()
              }
            }).finally(() => {
              self.loading = false;
            })
          } else if (this.tableActiveIndex === '2') {
            params = self.selectedRowsForEmployee.map(item => item.id)
            apiTeamEmployeeDel(params).then(res => {
              if (res?.code === 200) {
                self.$message.success(res?.msg || '操作成功')
                self.handleOk()
              }
            }).finally(() => {
              self.loading = false;
            })
          }
        }
      })
    },
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 操作日志弹窗
    handleLog(ids, type) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiGetLog({ id: ids, ...type }).then(res => {
        if (res.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    handleImportForEmployee() {
      this.$refs.importExcelForEmployeeRef.show()
    },
    // 导出
    handleExport() {
      if (this.tableActiveIndex === '1') {
        const params = this.$refs.dataTable.searchParams
        this.$refs.download.openModal(params)
      } else if (this.tableActiveIndex === '2') {
        const params = this.$refs.dataTableForEmployee.searchParams
        this.$refs.downloadForEmployee.openModal(params)
      }
    },
    // 行选中
    selectedRowChangeForEmployee(selectedRowKeys, selectedRows) {
      this.selectedRowKeysForEmployee = selectedRowKeys
      this.selectedRowsForEmployee = selectedRows
    },
    // 编辑
    handleEditForEmployee(record) {
      if (this.currentIdForEmployee && record.id !== this.currentIdForEmployee && this.isEditForEmployee) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }

      this.isEditForEmployee = true
      this.currentIdForEmployee = record.id
    },
    // 保存
    handleSaveForEmployee(record) {
      if (!record?.effectiveStartTime) {
        this.$message.warning('请输入生效日期')
        return
      }

      if (!record?.effectiveEndTime) {
        this.$message.warning('请输入失效日期')
        return
      }

      this.loading = true

      apiTeamEmployeeUpdate({
        ...record,
        employeeCodeList: [record.employeeCode]
      })
        .then((res) => {
          if (res?.code === 200) {
            this.$message.success('编辑成功')
            this.handleOk(true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 取消
    handleCancelForEmployee() {
      this.handleOk(true)
    }
  }
}
</script>

<style scoped lang="less">
.pub-select {
  /deep/ .ant-select {
    width: 100%;
  }
}
</style>
